<template>
  <div class="image-panel">
    <h2>Image</h2>
    <h-text-field label="Image Url" v-model="imageUrl" clearable></h-text-field>
    <p>NT: Named Transform</p>

    <div class="image-panel-bg">
      <h3>NT: mobileHeroImageHelper</h3>
      <h3>NT: smallHeroImageHelper</h3>
      <h-hero-banner-partner :img-source-mobile="imageUrl" :img-source-desktop="imageUrl"></h-hero-banner-partner>
      <p>
        smallHeroImageHelper
        <br />
        max-height: 240px;
        <br />
        max-width: 1200px;
        <br />
        ratio: {{ 1200 / 240 }}
      </p>
    </div>

    <div class="image-panel-bg">
      <h3>NT: showcaseImageHelper</h3>
      <img :src="showcaseImageHelper(imageUrl)" />
      <p>
        showcaseImageHelper
        <br />
        max-height: 237px;
        <br />
        max-width: 483px;
        <br />
        ratio: {{ 483 / 237 }}
      </p>
    </div>

    <div class="image-panel-bg">
      <h3>NT: consumer-gift-card-carousel</h3>
      <consumer-gift-card-carousel :images-urls="carouselImagesHelpers([imageUrl])" />
      <p>
        consumer-gift-card-carousel
        <br />
        max-height: 220px;
        <br />
        max-width: 450.2px;
        <br />
        ratio: {{ 450.2 / 220 }}
      </p>
    </div>

    <div class="image-panel-bg" style="max-width: 336px">
      <h3>NT: showcaseImageHelper safeZone 336px</h3>
      <div class="small-card-top-section" :style="{ backgroundImage: 'url(' + showcaseImageHelper(imageUrl) + ')' }">
        <h-chip-small></h-chip-small>
      </div>
      <p>
        showcaseImageHelper
        <br />
        max-height: 146.87px;
        <br />
        max-width: 336px;
        <br />
        ratio: {{ 336 / 146.87 }}
      </p>
    </div>

    <div class="image-panel-bg" style="max-width: 500px">
      <h3>NT: showcaseImageHelper safeZone 500px</h3>
      <div class="small-card-top-section" :style="{ backgroundImage: 'url(' + showcaseImageHelper(imageUrl) + ')' }">
        <h-chip-small></h-chip-small>
      </div>
    </div>

    <div class="image-panel-bg" style="max-width: 900px">
      <h3>NT: showcaseImageHelper safeZone 900px</h3>
      <div class="small-card-top-section" :style="{ backgroundImage: 'url(' + showcaseImageHelper(imageUrl) + ')' }">
        <h-chip-small></h-chip-small>
      </div>
    </div>
    <div class="image-panel-bg">
      <h3>NT: showcaseImageHelper safeZone full width</h3>
      <div class="small-card-top-section" :style="{ backgroundImage: 'url(' + showcaseImageHelper(imageUrl) + ')' }">
        <h-chip-small></h-chip-small>
      </div>
    </div>

    <div class="image-panel-bg">
      <h3>NT: carouselImagesHelpers</h3>
      <img max-height="7586px" style="width: 100%" :src="carouselImagesHelpers([imageUrl])" />
    </div>
    <div class="image-panel-bg" style="position: relative">
      <h3>NT: carouselImagesHelpers</h3>
      <div class="chip-slot">
        <h-chip-big></h-chip-big>
      </div>
      <v-carousel height="auto" hide-delimiters :show-arrows="false" next-icon="mdi-dark  mdi-chevron-right" prev-icon="mdi-dark mdi-chevron-left">
        <v-carousel-item v-for="(item, i) in carouselImagesHelpers([imageUrl])" :key="i" :src="item">
          <v-img :src="item" max-height="7586px" />
        </v-carousel-item>
      </v-carousel>
    </div>
    <div class="image-panel-bg">
      <h3>NT: horizontalLogoImageHelper</h3>
      <img class="partner-img" :src="horizontalLogoImageHelper(imageUrl)" />
      <p>
        horizontalLogoImageHelper
        <br />
        max-height: 36px;
        <br />
        max-width: 104px;
        <br />
        ratio: {{ 104 / 36 }}
      </p>
    </div>
    <div class="image-panel-bg">
      <h3>NT: showcaseSmall</h3>
      <img :src="showcaseSmall(imageUrl)" />
    </div>
    <div class="image-panel-bg">
      <h3>NT: spaceShowcaseImageHelper</h3>
      <img :src="spaceShowcaseImageHelper(imageUrl)" />
    </div>
    <div class="image-panel-bg">
      <h3>NT: spaceWidgetImageHelper</h3>
      <img :src="spaceWidgetImageHelper(imageUrl)" />
    </div>
    <div class="image-panel-bg">
      <h3>NT: mobileHeroImageHelper</h3>
      <img :src="mobileHeroImageHelper(imageUrl)" />
    </div>

    <div class="image-panel-bg">
      <h3>NT: recentlyVisitedImageHelper</h3>
      <img :src="recentlyVisitedImageHelper(imageUrl)" />
    </div>
    <div class="image-panel-bg">
      <h3>NT: marketingCategoryImageHelper</h3>
      <img :src="marketingCategoryImageHelper(imageUrl)" />
    </div>

    <div>
      <h3>NT: showcaseImageHelper</h3>
      <v-card class="marketing-offer-card" style="max-width: 300px">
        <div class="small-card-gift-search" :style="{ backgroundImage: `url(${showcaseImageHelper(imageUrl)})` }">
          <div class="h-text-4 home-card-status">askldjfh asdflkh dfslk</div>
        </div>
      </v-card>
      <p>
        showcaseImageHelper
        <br />
        max-height: 141.77px;
        <br />
        max-width: 292px;
        <br />
        ratio: {{ 292 / 141.77 }}
      </p>
    </div>

    <div class="image-panel-bg">
      <h3>Destination Button</h3>
      <destination-button :with-warning="false" text="MyName" :image-url="imageUrl"></destination-button>
      <p>
        Destination button
        <br />
        max-height: 124px;
        <br />
        max-width: 124px;
        <br />
        ratio: {{ 124 / 124 }}
      </p>
    </div>
    <div class="image-container image-panel-bg">
      <img class="main-image" :src="showcaseImageHelper(imageUrl)" />
      <p>
        Destination Showcase
        <br />
        max-height: 90px;
        <br />
        max-width: 180px;
        <br />
        ratio: {{ 180 / 90 }}
      </p>
    </div>
  </div>
</template>

<script>
import DestinationButton from '@/components/destination/DestinationButton.vue';
import ConsumerGiftCardCarousel from '@/components/consumer-gift-card/base-components/ConsumerGiftCardCarousel.vue';

import {
  smallHeroImageHelper,
  showcaseImageHelper,
  carouselImagesHelpers,
  horizontalLogoImageHelper,
  showcaseSmall,
  spaceShowcaseImageHelper,
  spaceWidgetImageHelper,
  mobileHeroImageHelper,
  recentlyVisitedImageHelper,
  marketingCategoryImageHelper,
} from '@/composables/image-helper.js';

export default {
  setup() {
    return {
      smallHeroImageHelper,
      showcaseImageHelper,
      carouselImagesHelpers,
      horizontalLogoImageHelper,
      showcaseSmall,
      spaceShowcaseImageHelper,
      spaceWidgetImageHelper,
      mobileHeroImageHelper,
      recentlyVisitedImageHelper,
      marketingCategoryImageHelper,
    };
  },
  components: {
    DestinationButton,
    ConsumerGiftCardCarousel,
  },
  name: 'image-panel',
  data() {
    return {
      imageUrl: 'https://images.hellocard.ca/brandings/BRN-WZKK-U3WK/offer-image-WNDU-RCWG.png',
    };
  },
};
</script>

<style lang="scss" scoped>
.image-panel-bg {
  background-color: bisque;
}

.image-container {
  display: flex;
  gap: var(--gap);

  @media ($md-min) {
    gap: var(--gap-small);
  }
}
.main-image {
  display: block;
  height: 90px;
  width: 180px;
  border-radius: var(--border-radius);
  margin: 0 var(--gap-xsmall);
  &:first-child {
    margin-left: 0;
  }

  @media ($md-min) {
    width: 200px;
    height: 100px;
    margin: 0;
  }
}

.small-card-top-section {
  position: relative;

  // This is the future
  //aspect-ratio: 1 / 0.490683;

  // Remove this padding-top property when you are no longer in the past.
  padding-top: 49.0683%;

  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

::v-deep .h-chip-small {
  position: absolute;
  right: 15px;
  top: 20px;
}

.chip-slot {
  position: relative;

  > * {
    position: absolute;
    z-index: 1;
    top: -20px;
    right: 0;

    @media ($md-min) {
      top: -75px;
      right: clamp(-100px, calc((100vw - var(--page-max-width)) * -1 / 2 + 10px), 0px);
    }
  }
}

.small-card-gift-search {
  position: relative;
  // This is the future
  // aspect-ratio: 2 / 1;
  // Remove this padding-top property when you are no longer in the past.
  padding-top: 48.554913%;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.home-card-status {
  bottom: 0;
  position: absolute;
  background-color: var(--color-warning);
  color: var(--color-ultra-light);
  font-weight: 600;
  line-height: 1.5;
  padding: 6px;
}

.partner-img {
  max-width: 104px;
  max-height: 36px;
  margin-left: 12px;
}

.marketing-offer-card {
  border-radius: 20px !important;
  box-shadow: none;
  border: 2px solid #e6eef8;
  background-color: #e6eef8 !important;
  padding: 2px !important;
  &:hover {
    cursor: pointer;
    opacity: 1 !important;
    transition: 0.25s ease-in-out;
    box-shadow: 0px 4px 20px 8px rgba(0, 0, 0, 0.12) !important;
  }
  &:not(:hover) {
    cursor: default;
    transition: 0.25s ease-in-out;
    box-shadow: none !important;
  }
  --home-card-badge: 36px;
  @media ($sm-min) {
    --home-card-badge: 28px;
  }
}
</style>
